"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BlockControls_1 = __importDefault(require("./BlockControls"));
var BlockControlsAngular = (function () {
    function BlockControlsAngular(mountReactComponent, blockList, block, telemetry, blockCreator, blockFetcher, $timeout, projectScrollTo, navigationHeaderHeight, notifyUser, deleteBlock) {
        this.ui = mountReactComponent(react_1.default.createElement(BlockControls_1.default, { block: block, blockList: blockList, telemetry: telemetry, blockCreator: blockCreator, blockFetcher: blockFetcher, "$timeout": $timeout, projectScrollTo: projectScrollTo, navigationHeaderHeight: navigationHeaderHeight, onDeleteBlock: deleteBlock, notifyUser: notifyUser }));
    }
    return BlockControlsAngular;
}());
exports.default = BlockControlsAngular;
